import { onMounted, onUnmounted } from 'vue';

const MODAL_ACTIVE_CLASS = 'modal-active';

export const useModalActive = () => {
    onMounted(() => {
        document.body.classList.add(MODAL_ACTIVE_CLASS);
        document.body.style.overflow = 'hidden';
    });

    onUnmounted(() => {
        document.body.classList.remove(MODAL_ACTIVE_CLASS);
        document.body.style.overflow = '';
    });
};
